import { render, staticRenderFns } from "./CourseView.vue?vue&type=template&id=f6fc7dde&"
import script from "./CourseView.vue?vue&type=script&lang=ts&"
export * from "./CourseView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports